import { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Button, ButtonGroup, Drawer, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Country } from 'country-state-city';
import { Icon } from '@iconify/react';
// import './AddAgents.scss';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  capitalizeFirstLetter,
  debounce,
  useAbort
} from '../../../../../utils/commonFunctions';
import {
  addAgent,
  agentValidation,
  clearMailError,
  clearUsers,
  getAgent,
  setValidationErrors,
  updateAgent
} from '../../../redux/reducer/autoPlannerSlices/agentslice';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import PhoneNoTextField from '../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import {
  getOperatorAdmin,
  getRolesDropdown
} from '../../../../../common/redux/reducer/commonSlices/roleSlice';

function AddOperator({
  setOpen,
  open,
  selected,
  isMapping,
  page,
  roles,
  tabValue,
  clearState,
  setIsScroll,
  setTabValue
}: any) {
  const [role, setRole] = useState(
    roles === 'ROLE_AGENT' ? 'sub Agent' : tabValue ? 'operation user' : 'operator'
  );
  const addAgentData = useAppSelector(state => state.agentOnboard);
  const updateAgentData = useAppSelector(state => state.autoAgentUpdate);
  const { data } = useAppSelector(state => state.auth);
  const profile = useAppSelector(state => state.myProfile.data);
  const [validationFields, setValidationFields] = useState<any>({
    mail: { status: false },
    userName: { status: false },
    mobileNumber: { status: false }
  });

  const [validationField, setValidationField] = useState('');
  const [validationErrors, setValidationErrorsMake] = useState<any>({
    mail: null,
    userName: null,
    mobileNumber: null
  });
  const mail = useAppSelector(state => state.agentValidation.email);
  const mobile = useAppSelector(state => state.agentValidation.mobileNumber);
  const user = useAppSelector(state => state.agentValidation.userName);
  const getRoles = useAppSelector(state => state.rolesUserId);
  const OperatorAdminDrop = useAppSelector(state => state.operaterAdmin);

  const [error, setError] = useState(false);

  const createAbort = useAbort();

  let roletype = data?.role;

  const APagent = roletype === 'ROLE_AGENT';
  const isOperatorAdmin = roletype === 'ROLE_OPERATOR';

  const OperatorAdim = OperatorAdminDrop?.data?.map((value: any) => ({
    id: value,
    label: value
  }));

  const RolesDropdown = getRoles?.data?.map((value: any) => ({
    id: value.roleName,
    label: value.roleName
  }));

  const isAddingAgent = !selected;

  const validationSchema = (selected: any, validationErrors: any) =>
    yup.object({
      agentname: yup
        .string()
        .required('Enter username')
        .matches(
          /^[a-z0-9]+$/,
          'Username can only contain lowercase letters and numbers without spaces'
        )
        .min(3, 'Username must contain at least 3 characters')
        .max(30, 'Username cannot exceed 30 characters')
        .test('agentname', 'Enter valid username', function (value: any) {
          if (
            validationErrors?.userName &&
            validationErrors?.userName !== 'no-error' &&
            value
          ) {
            return this.createError({ message: validationErrors?.userName });
          }
          return true;
        }),

      password:
        selected === null
          ? yup
              .string()
              .required('Enter password')
              .min(8, 'Password must be at least 8 characters')
              .max(16, 'Password must not exceed 16 characters')
              .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
              .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
              .matches(/[0-9]/, 'Password must contain at least one number')
              .matches(
                /[@$!%*?&#^()_\-+=]/,
                'Password must contain at least one special character'
              )
          : yup.string().notRequired(),

      confirmPassword:
        selected === null
          ? yup
              .string()
              .required('Enter confirm password')
              .max(20, 'Confirm password cannot exceed 20 characters')
              .oneOf([yup.ref('password')], 'Passwords must match')
          : yup.string().notRequired(),

      contactperson: yup
        .string()
        .required('Enter contact person name')
        .matches(
          /^[A-Za-z0-9-\s]+$/,
          'Contact person name must contain letters or numbers only'
        )
        .test(
          'at-least-one-letter',
          'Contact person name must contain at least one alphabet',
          value => /[A-Za-z]/.test(value || '')
        )
        .min(3, 'Contact person name must contain at least 3 characters')
        .max(50, 'Contact person name cannot exceed 50 characters'),

      phone: yup
        .string()
        .required('Enter contact number')
        .min(8, 'Enter valid contact number')
        .test('phone', 'Enter valid contact number', function (value: any) {
          if (
            validationErrors?.mobileNumber &&
            validationErrors.mobileNumber !== 'no-error' &&
            value
          ) {
            return this.createError({ message: validationErrors?.mobileNumber });
          }
          return true;
        }),

      email: yup
        .string()
        .required('Enter email address')
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
          'Enter a valid email address'
        )
        .email('Email format is invalid')
        .test('email', 'Enter valid email', function (value: any) {
          if (validationErrors?.mail && validationErrors.mail !== 'no-error' && value) {
            return this.createError({ message: validationErrors?.mail });
          }
          return true;
        }),

      // country: yup
      //   .string()
      //   .required('Select country')
      //   .matches(/^[A-Za-z ]+$/, 'Country name contains only alphabets'),

      roles: yup.string().when('role', {
        is: (y: string) => {
          return role && role === 'operation user';
        },
        then: schema => schema.required('Select  role'),
        otherwise: schema => schema.notRequired()
      })

      // parentRole: yup.string().when('role', {
      //   is: (role: string) => {
      //     return role && role === 'operation user';
      //   },
      //   then: schema => schema.required('Select parent role'),

      //   otherwise: schema => schema.notRequired()
      // }),

      // website: yup.string().notRequired()
    });

  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    setValue,
    trigger,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema(selected, validationErrors))
  });
  const removeSpecialCharacters = (phoneNumber: string): string => {
    return phoneNumber.replace(/\D/g, '');
  };

  const onSubmit = async (data: any) => {
    const getPayload = {
      pageNo: page,
      pageSize: 8,
      role: roles,
      category: role === 'operation user' ? 'OPERATION_USER' : '',
      signal: createAbort().abortCall.signal
    };
    if (!selected) {
      let payload = {
        userCredentialsReq: {
          userName: data.agentname,
          password: data?.password,
          confirmPassword: data?.confirmPassword
        },
        userOnboardProfileReq: {
          ...(data.parentRole !== '' && { parentName: data.parentRole }),
          country: data.country,
          email: data.email,
          contactNumber: `${data.phone}`,
          contactPersonName: data.contactperson,
          timezone: profile?.timezone || 'Asia/Singapore',
          ...(data.website !== '' && { website: data.website })
        },
        roleTypes: [data?.roles ? data?.roles : 'ROLE_OPERATOR']
      };
      const params = { getPayload, payload };
      const action = await dispatch(addAgent(params));
      if (action.type === addAgent.fulfilled.type) {
        setTabValue(role === 'operation user' ? 1 : 0);
        setIsScroll(false);
        clearState();
        dispatch(clearUsers());
        await dispatch(getAgent(getPayload));
        handleClose();
      }
    } else {
      let updatePayload = {
        userID: selected?.id,
        roleTypes: [data?.roles ? data?.roles : 'ROLE_OPERATOR'],
        userOnboardProfileReq: {
          ...(data.parentRole !== '' && { parentName: data.parentRole }),
          contactNumber: `${data.phone}`,
          country: data.country,
          contactPersonName: data.contactperson,
          email: data?.email,
          timezone: profile?.timezone || 'Asia/Singapore',
          ...(data.website !== '' && { website: data.website })
        }
      };
      const param = { getPayload, updatePayload };
      const action = await dispatch(updateAgent(param));

      if (action.type === updateAgent.fulfilled.type) {
        setIsScroll(false);
        clearState();
        dispatch(clearUsers());
        await dispatch(getAgent(getPayload));
        handleClose();
      }
    }
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  useEffect(() => {
    if (selected) {
      setValue('agentname', selected.userName);
      setValue('contactperson', selected.contactPersonName);
      setValue('roles', selected.roles?.[0].role || '');
      // setValue('parentRole', selected.parentName || '');
      setValue('phone', selected.contactNumber);
      // setValue('country', selected.country);
      setValue('email', selected.email);
      // setValue('website', selected.website);
      setRole(
        selected.roles?.includes('ROLE_OPERATOR')
          ? 'operation admin'
          : selected.roles?.includes('ROLE_AGENT')
          ? 'operation user'
          : 'sub Agent'
      );
    } else {
      reset();
    }
  }, [selected, setValue, reset]);

  useEffect(() => {
    if (APagent) setRole('sub Agent');
    if (!APagent) setRole(tabValue ? 'operation user' : 'operation admin');
    return () => {
      createAbort().abortCall.abort();
    };
  }, []);

  useEffect(() => {
    if (isOperatorAdmin) setRole('operation user');
  }, []);

  // useEffect(() => {
  //   dispatch(getMyProfileAction(createAbort().abortCall.signal));
  //   return () => {
  //     createAbort().abortCall.abort();
  //   };
  // }, []);
  const handleFilterChange = useCallback(
    debounce(async (event: string, field: any) => {
      let eventFilter = field === 'mobileNumber' ? 'mobileNumber' : field;
      setValidationField(field);

      dispatch(
        setValidationErrors({ fieldName: field, error: 'no-error', status: false })
      );
      setValidationFields((prev: any) => ({
        ...prev,
        [field]: { status: true }
      }));
      if (['email', 'userName', 'mobileNumber']?.includes(field) && event) {
        const response = await dispatch(
          agentValidation({
            category: eventFilter,
            value: event ? event : null,
            operation: selected ? 'update' : 'add',
            id: selected?.id
          })
        );

        if (field === 'mobileNumber' && response?.payload?.status !== 200) setError(true);
        dispatch(
          setValidationErrors({
            fieldName: field,
            error: response?.payload?.status !== 200 ? response.payload : '',
            status: false
          })
        );
        setValidationFields((prev: any) => ({
          ...prev,
          [field]: { status: false }
        }));
        trigger(field);
      }
    }),
    [dispatch]
  );

  useEffect(() => {
    setValidationErrorsMake({
      userName: user?.error,
      mobileNumber: mobile?.error,
      mail: mail?.error
    });
  }, [user, mobile, mail]);

  useEffect(() => {
    if (validationErrors?.mail) trigger('email');
  }, [validationErrors?.mail]);

  useEffect(() => {
    if (validationErrors?.mobileNumber) trigger('phone');
  }, [validationErrors?.mobileNumber, error]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (validationErrors?.userName) trigger('agentname');
  }, [validationErrors?.userName]);

  useEffect(() => {
    return () => {
      dispatch(clearMailError());
    };
  }, []);

  useEffect(() => {
    dispatch(getRolesDropdown());
    dispatch(getOperatorAdmin());
  }, []);

  return (
    <Box p={2}>
      <Drawer anchor='right' open={open} onClose={handleClose} sx={{ zIndex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant='h6' sx={{ fontWeight: 700, marginBottom: '10px' }}>
            {isMapping
              ? 'Driver & Vehicle Mapping'
              : isAddingAgent
              ? `Add ${capitalizeFirstLetter(role)}`
              : `Update ${capitalizeFirstLetter(role)}`}
          </Typography>
          <Box component='form' onSubmit={handleSubmit(onSubmit)}>
            {!APagent && !selected && !isOperatorAdmin ? (
              <Box className='role-layout'>
                <ButtonGroup variant='outlined' aria-label='Basic button group'>
                  <Button
                    onClick={() => {
                      setRole('operation admin');
                    }}
                    className={
                      role !== 'operation user'
                        ? 'layout-active layout-btn'
                        : 'layout-btn'
                    }
                  >
                    Operation Admin
                  </Button>
                  <Button
                    onClick={() => {
                      setRole('operation user');
                    }}
                    className={
                      role === 'operation user'
                        ? 'layout-active layout-btn'
                        : 'layout-btn'
                    }
                  >
                    Operation User
                  </Button>
                </ButtonGroup>
              </Box>
            ) : (
              ''
            )}

            <CustomTextField
              control={control}
              name='contactperson'
              placeholder='Contact person name'
              id='contactperson'
              label='Contact Person Name'
              maxlength={50}
              disabled={isAddingAgent ? false : true}
              defaultValue={selected?.displayName || ''}
            />
            {role === 'operation user' && (
              <CustomSelect
                control={control}
                options={RolesDropdown}
                name='roles'
                placeholder='Select the role'
                id='roles'
                label='Role'
              />
            )}
            {/*
            {role === 'operation user' && !isOperatorAdmin && (
              <CustomSelect
                control={control}
                options={OperatorAdim}
                name='parentRole'
                placeholder='Select the parent role'
                id='parentRole'
                label='Parent Role'
              />
            )} */}
            <Controller
              name='phone'
              control={control}
              defaultValue={selected?.mobileNumber || '+65'}
              rules={{ required: true }}
              render={({ field }) => (
                <PhoneNoTextField
                  {...field}
                  setValue={setValue}
                  style='share'
                  country='sg'
                  label='Contact Number'
                  onChange={(e: any) => {
                    if (e) {
                      handleFilterChange(e, 'mobileNumber');
                    }
                    trigger('phone');
                  }}
                  error={Boolean((errors as any)?.phone?.message)}
                  helperText={(errors as any)?.phone?.message}
                />
              )}
            />
            {/* {errors.phone && (
              <Typography
                sx={{
                  color: '#d32f2f',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  fontSize: '12px',
                  marginTop: '-5px',
                  fontWeight: 300,
                  marginBottom: '5px'
                }}
              >
                {errors.phone.message}
              </Typography>
            )} */}
            <CustomTextField
              control={control}
              name='email'
              placeholder='Email address'
              id='email'
              label='Email address'
              maxlength={50}
              defaultValue={selected?.email || ''}
              onChangeCallback={(e: any) => {
                if (e) {
                  handleFilterChange(e, 'email');
                }
                trigger('email');
              }}
            />
            <CustomTextField
              control={control}
              name='agentname'
              placeholder='Username'
              id='agentname'
              loading={
                validationFields?.userName?.status && validationField === 'userName'
              }
              label='Username'
              maxlength={30}
              disabled={isAddingAgent ? false : true}
              defaultValue={selected?.name || ''}
              onChangeCallback={(e: any) => {
                if (e) {
                  handleFilterChange(e, 'userName');
                }
                if (e.length > 1) {
                  trigger('agentname');
                }
              }}
            />
            {!selected && (
              <>
                <CustomTextField
                  label='Password'
                  id='password'
                  type='password'
                  placeholder='Password'
                  control={control}
                  name='password'
                  maxlength={16}
                  icon={
                    <Icon
                      icon='teenyicons:lock-outline'
                      width='15'
                      height='15'
                      style={{ color: 'black' }}
                    />
                  }
                />
                <CustomTextField
                  label='Confirm Password'
                  id='confirmPassword'
                  type='password'
                  maxlength={16}
                  placeholder='Confirm Password'
                  control={control}
                  name='confirmPassword'
                  icon={
                    <Icon
                      icon='teenyicons:lock-outline'
                      width='15'
                      height='15'
                      style={{ color: 'black' }}
                    />
                  }
                />
              </>
            )}
            {/* <CustomSelect
              control={control}
              options={Country.getAllCountries().map((country: any) => ({
                id: country?.name,
                label: country?.name,
                code: country.isoCode
              }))}
              name='country'
              placeholder='Country'
              id='country'
              label='Country'
              defaultValue={selected?.country || ''}
            />
            <CustomTextField
              control={control}
              name='website'
              placeholder='Website URL'
              id='website'
              isOptional={true}
              label='Website URL'
              maxlength={100}
              defaultValue={selected?.websiteLink || ''}
            /> */}
            <Box
              sx={{
                marginTop: '5%',
                display: 'flex',
                gap: '15px',
                justifyContent: 'end'
              }}
            >
              <CustomButton className='cancel' category='Cancel' onClick={handleClose} />
              <CustomButton
                className='saveChanges'
                type='submit'
                loading={addAgentData?.isLoading || updateAgentData?.isLoading}
                category='Save'
              />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}

export default AddOperator;
